// Helpers to auto-fill credentials when creating an employee. The clinic admin
// does not care about the login email/password at creation time (they can be
// changed later), so we prefill sensible, valid placeholders instead of forcing
// the admin to invent them. Email must stay valid (backend: @Email + NOT NULL
// UNIQUE on User) and unique; password must satisfy the min-6-char form rule.

const PASSWORD_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
const PASSWORD_LENGTH = 12;
const PLACEHOLDER_EMAIL_DOMAIN = 'placeholder.local';

// Use the platform CSPRNG with rejection sampling so the alphabet is sampled
// uniformly (a plain `byte % len` would bias the first 256 % len symbols).
const randomToken = (length) => {
  const unbiasedCeiling = 256 - (256 % PASSWORD_ALPHABET.length);
  let token = '';
  while (token.length < length) {
    const bytes = new Uint8Array(length - token.length);
    crypto.getRandomValues(bytes);
    for (let i = 0; i < bytes.length; i += 1) {
      if (bytes[i] < unbiasedCeiling) {
        token += PASSWORD_ALPHABET[bytes[i] % PASSWORD_ALPHABET.length];
      }
    }
  }
  return token;
};

export const generateRandomPassword = () => randomToken(PASSWORD_LENGTH);

export const generatePlaceholderEmail = () =>
  `angajat-${randomToken(8).toLowerCase()}@${PLACEHOLDER_EMAIL_DOMAIN}`;
